import { render, staticRenderFns } from "./ArtworkContent.vue?vue&type=template&id=d8c71dd0&scoped=true"
import script from "./ArtworkContent.vue?vue&type=script&lang=js"
export * from "./ArtworkContent.vue?vue&type=script&lang=js"
import style0 from "./ArtworkContent.vue?vue&type=style&index=0&id=d8c71dd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c71dd0",
  null
  
)

export default component.exports